export const GIVEAWAY_PICKER_SIGNIN = `/lead/api-profiles/instagram`;
export const GIVEAWAY_PICKER_POSTS = `/giveaway-picker/medias`;
export const GIVEAWAY_PICKER_DRAW = `/giveaway-picker/draw`;
export const GIVEAWAY_PICKER_RESULT = `/giveaway-picker/results`;
